<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div *transloco="let t; prefix: 'pages.clinch.result'" [ngStyle]="drawerStyles | theme" class="result-drawer">
    <div [ngClass]="glowClass"></div>

    <app-nav-button icon="close" (clickEvent)="onCloseClick()"
      [variant]="drawerConfig.closeButtonInverted ? 'secondary' : 'primary'"
      [size]="drawerConfig.closeButtonSize" [ngClass]="drawerConfig.closeButtonPosition" />

    <canvas id="myConfettiCanvas" [hidden]="worldWide"></canvas>

    <div class="result-drawer-content">
        <app-game-icon *ngIf="drawerConfig.hasGameIcon" [game]="viewModel.gameId" class="game-icon"/>

        <app-game-title [wordmarkUrl]="themeService.wordmarkUrl(viewModel.gameId)" [title]="viewModel.gameName" class="game-name"/>
    
        <div *ngIf="viewModel.subtitle && !worldWide" [ngStyle]="bodyStyles | theme" class="title">
            {{ viewModel.subtitle }}
        </div>
    
        <div *ngIf="currencyAmount && !isFreeGame" class="amount">
            <span *ngIf="!worldWide" class="ascii-icon" [ngStyle]="{'color': asciiIconColor}">{{ viewModel.ascii }}</span>
            <span [ngStyle]="amountStyles | theme"> {{ currencyAmount }}</span>
            <app-currency-icon *ngIf="currencyIcon" [icon]="currencyIcon" sizeCss="--icon-x-large"></app-currency-icon>
            <app-bounty-pill *ngIf="wonBountyAmount" size="large" [amount]="wonBountyAmount"/>
        </div>
    
        <div class="tournament-info" *ngIf="viewModel.tournamentTitle">
            <div [ngStyle]="bodyStyles | theme">
                {{ viewModel.tournamentTitle }}
            </div>
            <app-icon icon="trophy" colorCss="'var(--content-primary)'" sizeCss="--icon-medium" />
        </div>
    
        <div class="players nick">
            <div class="player">
                <div *ngIf="viewModel.playerName"
                    role="button"
                    (click)="onPlayerClick(viewModel.playerId)"
                    [ngStyle]="playerStyles | theme">
                    {{ viewModel.playerName }}
                </div>
                <div *ngIf="!viewModel.playerName"
                    role="button"
                    (click)="onPlayerClick(currentUserId)"
                    [ngStyle]="playerStyles | theme">
                    {{ t('you')}}
                </div>
                <app-profile-button  *ngIf="themeService.hasProfileIconButton()" [variant]="isInverted ? 'secondary' : 'primary'" (clickEvent)="onPlayerClick(viewModel.playerName ? viewModel.playerId : currentUserId)" />
            </div>
            <div class="player">
                <div 
                    role="button"
                    [ngClass]="{ 'player-name': viewModel.opponentId }" (click)="onPlayerClick(viewModel.opponentId)"
                    *ngIf="viewModel.opponentName"
                    [ngStyle]="playerStyles | theme">
                    {{ viewModel.opponentName }}
                </div>
                <app-profile-button  *ngIf="themeService.hasProfileIconButton()" [variant]="isInverted ? 'secondary' : 'primary'" (clickEvent)="onPlayerClick(viewModel.opponentId)" />
            </div>
        </div>
    

        <div *ngIf="viewModel.scoreStatus === ScoreStatus.Finished" class="scoreboard">
            <div class="score-card" [ngStyle]="scoreCardStyles | theme">
                <div class="score-card-content">
                    <div [ngStyle]="scoreStatusStyles | theme">
                        {{ viewModel.yourScore }}
                    </div>
                </div>
            </div>
    
            <div class="score-card" [ngStyle]="scoreCardStyles | theme">
                <div class="score-card-content">
                    <div [ngStyle]="scoreStatusStyles | theme">   
                        {{ viewModel.opponentScore }}
                    </div>
                </div>
            </div>
        </div>
    
        <div *ngIf="viewModel.scoreStatus !== ScoreStatus.Finished" class="scoreboard">
    
            <div class="score-card" [ngStyle]="scoreCardStyles | theme">
                <div class="score-card-content">
                    <div [ngStyle]="scoreStatusStyles | theme">
                        {{ viewModel.yourScore }}
                    </div>
                </div>
            </div>
    
            <div class="score-card" [ngStyle]="scoreCardStyles | theme">
                <div class="score-card-content">
                    <div [ngStyle]="scoreStatusStyles | theme">
                        {{ viewModel.opponentStatus }}
                    </div>
                </div>
            </div>
        </div>
    
        <div 
            *ngIf="viewModel.roomTimer && !isFreeGame && !OperatorService.IsDemo"
            [ngStyle]="bodyStyles | theme"
            class="date"
        >
            {{ viewModel.roomTimer.message$ | async }}
        </div>
    
        <div 
            *ngIf="!isFreeGame && !OperatorService.IsDemo && !worldWide"
            [ngStyle]="matchIdStyles | theme"
            class="match-id"
        >
            ID: {{ viewModel.roomId }}
        </div>
    
        <div 
            *ngIf="viewModel.freeCta && isFreeGame && !OperatorService.IsDemo && !worldWide"
            [ngStyle]="bodyStyles | theme"
            class="free-cta"
        >
            <span>{{ viewModel.freeCta }}</span>
        </div>
    
        <app-button *ngIf="isAfterGame && !worldWide" [label]="t('finish')" stretch="fill" (clickEvent)="onFinishClick()" class="button"></app-button>    
    </div>
</div>